import React, { useEffect, useState } from 'react';
import { GetAuth } from '../../Auth/AuthProvider';

import UnauthorisedAccess from '../CommonComponents/UnauthorisedAccess';
import { r2_noHeaderTableUpdate } from '../../Helpers/r2_requests';

import { DataGrid } from '@mui/x-data-grid';
import { Grid, Modal, Box, TextField, Button } from '@mui/material';

import PermissionsAutocomplete from '../CommonComponents/PermissionsAutocomplete';

import UserEdit from './UsersEdit';

import { gridStyle } from '../shared/commonStyle';

import { changeFirstToUpper } from '../../Helpers/helpers';

const UsersAdmin = () => {
  const [data, setData] = useState([]);
  const [forceUpdate, setForceUpdate] = useState(1);

  const [totalRows, setTotalRows] = useState(0);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(25);
  const [filter, setFilter] = useState([]);
  const [sort, setSort] = useState([]);
  const [loading, setLoading] = useState(false);
  const enqNotification = GetAuth().Notification;
  const logout = GetAuth().signOut;
  const [updateData, setUpdateData] = useState(0);

  const [useType, setUseType] = useState(localStorage.getItem('type'));
  //FILTERS

  const [byUserName, setByUserName] = useState('');
  const [fullFilterBlob, setFullFilterBlob] = useState([]);

  const [rowData, setRowData] = useState({});

  const [open, setOpen] = useState(false);
  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    setForceUpdate(forceUpdate + 1);
  };

  const changeHandler = (event) => {
    let oldData = [...fullFilterBlob];
    let tempData = oldData.slice().filter((item) => item.field !== 'username');

    setFullFilterBlob([
      ...tempData,
      {
        field: 'username',
        search: event.target.value,
        strict: false,
      },
    ]);

    setByUserName(event.target.value);
  };

  // const debouncedChangeHandler = useMemo(() => {
  //   return debounce(changeHandler, 800);
  // }, []);

  const handleFilterChange = (data, type) => {
    switch (type) {
      case 'permissions':
        let oldData = [...fullFilterBlob];
        let tempData = oldData.slice().filter((item) => item.field !== 'type');
        setFullFilterBlob([
          ...tempData,
          {
            field: 'type',
            search: data,
            strict: true,
          },
        ]);
        break;
      default:
        // console.log(data);
        break;
    }
  };

  useEffect(() => {
    r2_noHeaderTableUpdate(
      {
        resource: `/api/r2_users`,
        setDataFunc: setData,
        pageNum: page,
        setLoadingFunc: setLoading,
        pagesize: pageSize,
        sorting: sort,
        filtering: filter,
        showNotification: enqNotification,
        setRows: setTotalRows,
        logout,
        fullFilters: fullFilterBlob,
        rangeFilters: [],
      },
      'r2_users'
    );
  }, [
    page,
    pageSize,
    sort,
    filter,
    updateData,
    enqNotification,
    logout,
    fullFilterBlob,
    forceUpdate,
  ]);
  const columns = [
    { field: 'username', headerName: 'Username', width: 150, flex: 1 },
    { field: 'name', headerName: 'Name & Surname', width: 150, flex: 1 }, // Backend to use original
    { field: 'surname', headerName: 'Department', width: 150, flex: 1 }, // Backend to use original
    {
      field: 'type',
      headerName: 'User Type',
      width: 150,
      flex: 1,
      renderCell: (data) => <>{changeFirstToUpper(data.row.type)}</>,
    },
    {
      field: 'contact_number',
      headerName: 'Contact Number',
      width: 150,
      flex: 1,
    },
    {
      field: 'active',
      headerName: 'Active',
      width: 150,
      flex: 1,
      valueGetter: ({ value }) => isActive(value),
    },
    {
      field: 'actions',
      headerName: 'Actions',
      width: 150,
      flex: 1,
      renderCell: (data) => (
        <>
          <Button
            variant='contained'
            size='small'
            onClick={() => {
              setRowData(data.row);
              handleOpen();
            }}
          >
            Edit
          </Button>
        </>
      ),
    },
  ];

  return useType !== 'manager' ? (
    <UnauthorisedAccess />
  ) : (
    <Box style={{ height: '72vh', width: '100%' }}>
      <Box sx={{ margin: '0 0 10px 0' }}>
        <Grid container>
          <Grid xs={12} md={3}>
            <PermissionsAutocomplete
              setByType={(data) => handleFilterChange(data, 'permissions')}
              nameLabel='Filter By Permission Type'
              id='permissionType'
            />
          </Grid>
          <Grid xs={12} md={3}></Grid>
          <Grid xs={12} md={3}></Grid>
          <Grid xs={12} md={3}>
            <TextField
              id='byUserName'
              sx={{ width: '80%' }}
              label='Filter By Username'
              variant='outlined'
              // value={byUserName}
              onChange={(event) => changeHandler(event)}
              // onChange={debouncedChangeHandler}
              // onChange={(event) => handleChange(event)}
            >
              {byUserName}
            </TextField>
          </Grid>
        </Grid>
      </Box>
      <DataGrid
        sx={gridStyle}
        rows={data}
        rowCount={totalRows}
        loading={loading}
        pagination
        sortingMode='server'
        filterMode='server'
        onSortModelChange={(model) => {
          setPage(0);
          setSort(model);
        }}
        onFilterModelChange={(model) => {
          setPage(0);
          setFilter(model.quickFilterValues);
        }}
        page={page}
        pageSize={pageSize}
        paginationMode='server'
        onPageChange={(newPage) => {
          setPage(newPage);
        }}
        onPageSizeChange={(newPageSize) => {
          setPage(0);
          setPageSize(newPageSize);
        }}
        columns={columns}
        onRowClick={(params) => {}}
        onRowDoubleClick={(params) => {
          setRowData(params.row);
          handleOpen();
        }}
        rowsPerPageOptions={[25, 50, 100]}
        // components={{ Toolbar: CustomCustomerToolbar }}
        disableColumnFilter
        disableColumnSelector
        disableDensitySelector
        componentsProps={{
          toolbar: {
            updateOnclick: () => {
              setUpdateData((i) => i + 1);
            },
            filterOnClick: () => {
              // handleFilterOpen();
            },
            // modalState: modalState,
          },
        }}
      />
      <Button
        sx={{ float: 'right', margin: '15px 0 0 0 ' }}
        variant='contained'
        size='small'
        onClick={() => {
          setRowData(newRowData);
          handleOpen();
        }}
      >
        add
      </Button>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby='parent-modal-Time_Attendance'
        aria-describedby='parent-modal-Time_Attendance_Row_Edit'
      >
        <UserEdit thisRowData={rowData} cancelEdit={handleClose} />
      </Modal>
    </Box>
  );
};

export default UsersAdmin;

const isActive = (value) => {
  const active = value === true ? 'Yes' : 'No';
  return active;
};

const newRowData = {
  permissions: {
    super_admin: false,
    manager: false,
    supervisor: false,
    controller: false,
    finance: false,
    technician: false,
  },
};
